import type { ProductSpecification, Scores } from '../models/product'
import type { Line, TableData } from '../models/productComparison'

export function getSpecificationField(
  productsSpectifications: ProductSpecification[][],
  field: string,
): Line {
  let title = ''
  const values = productsSpectifications.map((productsSpectification) => {
    const productSpecification = productsSpectification.find(
      (i) => i.field === field,
    )
    if (!productSpecification) return null
    if (productSpecification.display) title = productSpecification.display

    return productSpecification.values.map((i) => i.label).join(', ')
  })

  return {
    type: 'text',
    title,
    values,
  }
}

export function getSpecificationFields(
  productsSpectification: ProductSpecification[][],
  fields: string[],
): Line[] {
  return fields.map((field) =>
    getSpecificationField(productsSpectification, field),
  )
}

export function getScoreField(
  scores: Scores[],
  scoreField: keyof Scores,
): Line {
  return {
    type: 'scores',
    values: scores.map((score) => parseFloat(score?.[scoreField] ?? '0')),
  }
}

export function cleanTableData(table: TableData[]) {
  for (const tableGroup of table) {
    for (const section of tableGroup.sections) {
      // Filter empty lines
      section.lines = section.lines.filter((line) => {
        if (line.type === 'colors' || line.type === 'tags')
          return line.values?.find((v) => v?.length > 0)
        if (line.type === 'ratings' || line.type === 'scores')
          return line.values?.find((v) => v > 0)
        if (line.type === 'info') return !!line.value

        return line.values?.find((v) => !!v)
      })
    }
    // Filter empty sections
    tableGroup.sections = tableGroup.sections.filter(
      (section) => !!section.lines?.length,
    )
  }

  // Filter empty tableGroups
  return table.filter((tableGroup) => !!tableGroup.sections.length)
}
